/* eslint-disable @typescript-eslint/naming-convention */
import { oz } from '@weft/utils';

export const SlackActionSchema = oz.object({
  type: oz.string(),
  text: oz.object({
    type: oz.string(),
    text: oz.string(),
  }),
  action_id: oz.string(),
  block_id: oz.string().optional(),
  value: oz.string(),
}).openapi('SlackAction');

export type SlackAction = oz.infer<typeof SlackActionSchema>;
